// App-root F7 push sheet listing outbox items. Mounted once (closed) and opened
// imperatively via f7.sheet.open() from any PendingSyncTrigger badge.
// Don't mount with opened={true}: F7-React pre-adds .modal-in, so F7's open() bails.
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { Sheet, Toolbar, Link, List, ListItem, PageContent, Block, f7 } from "framework7-react";
import { retryFailedNow } from "./sync";
import PendingSyncItem, { syncSummary } from "./PendingSyncItem";

const SHEET = ".pending-sync-sheet";

export const PendingSyncTrigger = ({ children }) => (
  <span
    role="button"
    style={{ display: "inline-flex", gap: 6, alignItems: "center", cursor: "pointer" }}
    onClick={() => f7.sheet.open(SHEET)}
  >
    {children}
  </span>
);

const mapStateToProps = (state) => ({
  pendingItems: state.offline_status?.pendingItems || [],
  online: state.offline_status?.online,
  syncing: state.offline_status?.syncing,
  lastSyncedAt: state.offline_status?.lastSyncedAt,
  projects: state.projects,
});

const lastSyncedLabel = (lastSyncedAt) => {
  if (!lastSyncedAt) return "Not synced yet";
  return `Last synced ${moment(lastSyncedAt).fromNow()}`;
};

const projectNameFor = (item, projects) => {
  if (!item.projectId) return null;
  return projects?.[item.projectId]?.display_name || projects?.[String(item.projectId)]?.display_name || null;
};

const PendingSyncSheet = ({ pendingItems, online, syncing, lastSyncedAt, projects }) => {
  const onSyncNow = () => {
    if (!online || syncing) return;
    retryFailedNow();
  };
  const summary = syncSummary(pendingItems);

  return (
    <Sheet className={SHEET.slice(1)} push swipeToClose backdrop>
      <Toolbar>
        <div className="left" style={{ paddingLeft: 16 }}>
          {pendingItems.length} to Sync
        </div>
        <div className="right" style={{ display: "flex", gap: 12, paddingRight: 8 }}>
          <Link onClick={onSyncNow}>
            {syncing ? "Syncing…" : online ? "Sync now" : "Waiting for Lion"}
          </Link>
          <Link sheetClose>Close</Link>
        </div>
      </Toolbar>
      <PageContent>
        <Block style={{ marginTop: 12, color: "var(--f7-text-color-secondary, #888)" }}>
          {lastSyncedLabel(lastSyncedAt)}
          {summary ? ` — ${summary}` : ""}
          {!online && " — saves stay on this phone until Lion is reachable."}
        </Block>
        <List mediaList>
          {_.isEmpty(pendingItems) ? (
            <ListItem title="Nothing to sync" />
          ) : (
            _.map(_.sortBy(pendingItems, "createdAt").reverse(), (item) => (
              <PendingSyncItem key={item.id} item={item} projectName={projectNameFor(item, projects)} />
            ))
          )}
        </List>
      </PageContent>
    </Sheet>
  );
};

export default connect(mapStateToProps)(PendingSyncSheet);
